export const GT_REVIEW_ONLY_MESSAGE = 'Local review-only mode — launch disabled. Save and Re-check remain available.';

export function isLocalGtReviewOnly(destination, env = process.env) {
  return destination === 'groundtruth' && env.NODE_ENV === 'development'
    && env.REACT_APP_GT_REVIEW_ONLY === 'true';
}
